"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeObject = exports.decodeShard = exports.decodeSplit = exports.decodeAllocation = exports.decodeValue = exports.decodeVariations = exports.decodeFlag = void 0;
const interfaces_1 = require("./interfaces");
const obfuscation_1 = require("./obfuscation");
function decodeFlag(flag) {
    return Object.assign(Object.assign({}, flag), { variations: decodeVariations(flag.variations, flag.variationType), allocations: flag.allocations.map(decodeAllocation) });
}
exports.decodeFlag = decodeFlag;
function decodeVariations(variations, variationType) {
    return Object.fromEntries(Object.entries(variations).map(([, variation]) => {
        const decodedKey = (0, obfuscation_1.decodeBase64)(variation.key);
        return [decodedKey, { key: decodedKey, value: decodeValue(variation.value, variationType) }];
    }));
}
exports.decodeVariations = decodeVariations;
function decodeValue(encodedValue, type) {
    switch (type) {
        case interfaces_1.VariationType.INTEGER:
        case interfaces_1.VariationType.NUMERIC:
            return Number((0, obfuscation_1.decodeBase64)(encodedValue));
        case interfaces_1.VariationType.BOOLEAN:
            return (0, obfuscation_1.decodeBase64)(encodedValue) === 'true';
        default:
            return (0, obfuscation_1.decodeBase64)(encodedValue);
    }
}
exports.decodeValue = decodeValue;
function decodeAllocation(allocation) {
    return Object.assign(Object.assign({}, allocation), { key: (0, obfuscation_1.decodeBase64)(allocation.key), splits: allocation.splits.map(decodeSplit), startAt: allocation.startAt
            ? new Date((0, obfuscation_1.decodeBase64)(allocation.startAt)).toISOString()
            : undefined, endAt: allocation.endAt ? new Date((0, obfuscation_1.decodeBase64)(allocation.endAt)).toISOString() : undefined });
}
exports.decodeAllocation = decodeAllocation;
function decodeSplit(split) {
    return {
        extraLogging: split.extraLogging ? decodeObject(split.extraLogging) : undefined,
        variationKey: (0, obfuscation_1.decodeBase64)(split.variationKey),
        shards: split.shards.map(decodeShard),
    };
}
exports.decodeSplit = decodeSplit;
function decodeShard(shard) {
    return Object.assign(Object.assign({}, shard), { salt: (0, obfuscation_1.decodeBase64)(shard.salt) });
}
exports.decodeShard = decodeShard;
function decodeObject(obj) {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [(0, obfuscation_1.decodeBase64)(key), (0, obfuscation_1.decodeBase64)(value)]));
}
exports.decodeObject = decodeObject;
//# sourceMappingURL=decoding.js.map